module.exports = __webpack_public_path__ + "static/media/close.8821ef52.svg";